import BaseResource from './index'
import ImageResource from './image'
import CalendarTypeResource from './calendartype'
import LocationResource from './location'

export default class PackageDealResource extends BaseResource {
    static endpoint = '/deals'

    static related() {
        return {
            hero_image: ImageResource,
            calendar_type: CalendarTypeResource,
            location: LocationResource,
        }
    }

    heroImageUrl() {
        return this.attributes.readonly_values?.hero_image_url || null
    }

    currencySymbol() {
        return this.attributes.readonly_values?.currency_symbol || '$'
    }

    toString() {
        return this.attributes.name
    }
}
